import { useContext } from 'react'
import { StoreContext } from '../providers/storeProvider'

export const useStoreContext = () => useContext(StoreContext)
